import React, { Component } from "react";
import config from "react-global-configuration";
import RequestApi from "../Miscelania/RequestApi";

import { Link } from "react-router-dom";
import Topo from "../Layout/Topo";
import Overlay from "../Miscelania/Overlay";

// Helpers de formulário
import Select from "react-select";
import InputMask from "react-input-mask";

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";

class StaffsFullSearch extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: "",
        type: "",
        status: "open",
      },
      redirect_url: false,
      loaded: 0,
      active: 0,
      search: 0,
      data: [],
      certifications: [],
      data: [],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.searchFull = this.searchFull.bind(this);
    this.loadData = this.loadData.bind(this);
    this.exportFull = this.exportFull.bind(this);
    this.exportConditions = this.exportConditions.bind(this);
  }

  // Handlers
  handleAlert(message, type, status, mode) {
    if (mode === "reset") {
      this.setState({ overlay: { message: "", type: "", status: "closed" } });
    } else {
      this.setState({
        overlay: { message: message, type: type, status: status },
      });
    }
  }

  handleLoaded(state) {
    if (this.state.loaded !== 2) {
      this.setState({ loaded: state });
    }
  }

  handleMessage() {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== "undefined") {
      message = JSON.parse(message);
      var self = this;
      self.setState({
        overlay: {
          message: message.alert_message,
          type: message.alert_type,
          status: "open",
        },
      });
      localStorage.removeItem("verify_message");
    }
  }

  // Handlers
  handleChange(name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleSelectChange(name, event) {
    var change = {};
    if (event == null) {
      change[name] = null;
    } else {
      change[name] = event;
    }
    this.setState(change);
  }

  componentDidMount() {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({ loaded: 2 }, this.loadData());
    }
  }

  searchFull(event) {
    event.preventDefault();
    this.handleAlert("", "", "open");
    var datasave = {
      fields: this.state.fields,
      staff_ids: this.state.staff_ids,
      certification_ids: this.state.certification_ids,
      role_ids: this.state.role_ids,
      aircraft_model_ids: this.state.aircraft_model_ids,
      aircraft_model_subtype_ids: this.state.aircraft_model_subtype_ids,
      active: this.state.active,
    };

    var header = this.refs.request_api.header("application/json");
    var self = this;
    Promise.resolve(header).then(function (value) {
      fetch(config.get("api") + "/controle/pesquisa/geral/condicoes", {
        method: "POST",
        mode: "cors",
        headers: value,
        body: JSON.stringify(datasave),
      })
        .then((response) => response.json())
        .catch((error) => {
          console.error(error);
        })
        .then((responseJson) => {
          self.refs.request_api.validate(responseJson, "alert");
          if (responseJson.status === "success") {
            self.setState({
              data: responseJson.data.main,
              titles: responseJson.data.titles,
              search: 1,
            });
          }
          self.setState({
            overlay: { message: "", type: "", status: "closed" },
          });
        })
        .catch((error) => {
          console.error(error);
        });
    });
  }

  exportConditions(event) {
    this.handleAlert("", "", "open");
    var datasave = {
      fields: this.state.fields,
      staff_ids: this.state.staff_ids,
      certification_ids: this.state.certification_ids,
      role_ids: this.state.role_ids,
      aircraft_model_ids: this.state.aircraft_model_ids,
      aircraft_model_subtype_ids: this.state.aircraft_model_subtype_ids,
      active: this.state.active,
    };

    var header = this.refs.request_api.header("application/json");
    var self = this;
    Promise.resolve(header).then(function (value) {
      fetch(config.get("api") + "/exportar/pesquisa/geral/condicoes", {
        method: "POST",
        mode: "cors",
        headers: value,
        body: JSON.stringify(datasave),
      })
        .then((response) => response.json())
        .catch((error) => {
          console.error(error);
        })
        .then((responseJson) => {
          self.refs.request_api.validate(responseJson, "alert");
          if (responseJson.status === "success") {
            self.setState({
              overlay: { message: "", type: "", status: "closed" },
            });
            window.open(config.get("cdn") + "/tmp/" + responseJson.data);
          }
          self.setState({
            overlay: { message: "", type: "", status: "closed" },
          });
        })
        .catch((error) => {
          console.error(error);
        });
    });
  }

  loadData() {
    var self = this;
    var header = this.refs.request_api.header("application/json");
    Promise.resolve(header).then(function (value) {
      fetch(config.get("api") + "/controle/pesquisa/geral/completa", {
        method: "GET",
        mode: "cors",
        headers: value,
      })
        .then((response) => response.json())
        .catch((error) => {
          console.error(error);
        })
        .then((responseJson) => {
          self.refs.request_api.validate(responseJson, "url");
          if (responseJson.status === "success") {
            self.setState({
              data: responseJson.data.main,
              staff_list: responseJson.data.staff_list,
              aircraft_models_list: responseJson.data.aircraft_models_list,
              aircraft_model_subtypes_list:
                responseJson.data.aircraft_model_subtypes_list,
              simple_list: responseJson.data.simple_list,
              certifications_list: responseJson.data.certifications_list,
              roles_list: responseJson.data.roles_list,
              titles: responseJson.data.titles,
              titles_list: responseJson.data.titles_list,
            });
          }
        })
        .then(() => {
          self.setState({
            overlay: { message: "", type: "", status: "closed" },
          });
          self.handleMessage();
        }); /* Overlay */
    });
  }

  exportFull(event) {
    var self = this;
    this.handleAlert("", "", "open");
    var url = "/exportar/pesquisa/geral";
    var header = this.refs.request_api.header("application/json");
    self.setState({ overlay: { message: "", type: "", status: "open" } });
    Promise.resolve(header).then(function (value) {
      fetch(config.get("api") + url, {
        method: "GET",
        mode: "cors",
        headers: value,
      })
        .then((response) => response.json())
        .catch((error) => {
          console.error(error);
        })
        .then((responseJson) => {
          self.refs.request_api.validate(responseJson, "url");
          if (responseJson.status === "success") {
            self.setState({
              overlay: { message: "", type: "", status: "closed" },
            });
            window.open(config.get("cdn") + "/tmp/" + responseJson.data);
          }
          self.handleAlert("", "", "closed");
        });
    });
  }

  render() {
    var self = this;
    return (
      <div>
        <Topo></Topo>
        <RequestApi ref={"request_api"} handleLoaded={this.handleLoaded} />
        <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
        <div className="container-liquid">
          <div className="conteudo">
            <h3 className="page-title">Pesquisa geral</h3>
            <hr />
            <form onSubmit={this.searchFull}>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Colaboradores:</label>
                    <Select
                      className=""
                      name="staff_ids"
                      value={this.state.staff_ids}
                      searchable={true}
                      multi={true}
                      placeholder={"Selecionar colaboradores"}
                      onChange={this.handleSelectChange.bind(this, "staff_ids")}
                      options={this.state.staff_list}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Ativos?</label>
                    <Select
                      className=""
                      name="active"
                      value={this.state.active}
                      searchable={true}
                      placeholder={"Selecionar ativos?"}
                      onChange={this.handleSelectChange.bind(this, "active")}
                      options={this.state.simple_list}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Frotas:</label>
                    <Select
                      className=""
                      name="aircraft_model_ids"
                      value={this.state.aircraft_model_ids}
                      searchable={true}
                      multi={true}
                      placeholder={"Selecionar frotas"}
                      onChange={this.handleSelectChange.bind(
                        this,
                        "aircraft_model_ids"
                      )}
                      options={this.state.aircraft_models_list}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Motores:</label>
                    <Select
                      className=""
                      name="aircraft_model_subtype_ids"
                      value={this.state.aircraft_model_subtype_ids}
                      searchable={true}
                      multi={true}
                      placeholder={"Selecionar motores"}
                      onChange={this.handleSelectChange.bind(
                        this,
                        "aircraft_model_subtype_ids"
                      )}
                      options={this.state.aircraft_model_subtypes_list}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Funções:</label>
                    <Select
                      className=""
                      name="role_ids"
                      value={this.state.role_ids}
                      searchable={true}
                      multi={true}
                      placeholder={"Selecionar funções"}
                      onChange={this.handleSelectChange.bind(this, "role_ids")}
                      options={this.state.roles_list}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Certificados:</label>
                    <Select
                      className=""
                      name="certification_ids"
                      value={this.state.certification_ids}
                      searchable={true}
                      multi={true}
                      placeholder={"Selecionar certificados"}
                      onChange={this.handleSelectChange.bind(
                        this,
                        "certification_ids"
                      )}
                      options={this.state.certifications_list}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Exibir os seguintes campos:</label>
                    <Select
                      className=""
                      name="fields"
                      value={this.state.fields}
                      searchable={true}
                      multi={true}
                      placeholder={"Selecionar campos da tabela"}
                      onChange={this.handleSelectChange.bind(this, "fields")}
                      options={this.state.titles_list}
                    />
                  </div>
                </div>
              </div>
              <div>
                <button type="submit" className="btn btn-primary btn-block">
                  <i className="fa fa-fw fa-search"></i> Filtrar
                </button>
              </div>
            </form>
            <hr />
            {this.state.search == 0 ? (
              <button
                className="btn btn-success pull-left"
                onClick={() => {
                  this.exportFull();
                }}
              >
                <i className="fa fa-fw fa-file-pdf-o"></i>Exportar XLSX
              </button>
            ) : (
              <button
                className="btn btn-success pull-left"
                onClick={() => {
                  this.exportConditions();
                }}
              >
                <i className="fa fa-fw fa-file-pdf-o"></i>Exportar XLSX
              </button>
            )}
            <div className="clearfix"></div>
            {typeof this.state.titles !== "undefined" ? (
              <BootstrapTable
                data={this.state.data}
                pagination={true}
                striped={true}
                hover={true}
                exportCSV={false}
                options={{
                  exportCSVText: "Exportar CSV",
                  noDataText: "Não há colaborador cadastrados",
                }}
                search={true}
                multiColumnSearch={true}
                searchPlaceholder="Procurar"
              >
                {Object.keys(self.state.titles).map(function (t) {
                  var data = self.state.titles[t];
                  if (t > 0) {
                    return (
                      <TableHeaderColumn
                        dataField={data.field}
                        dataAlign="center"
                        dataSort={true}
                        filter={{
                          type: "TextFilter",
                          delay: 200,
                          placeholder: "Procurar",
                        }}
                        width="280"
                      >
                        {data.title}
                      </TableHeaderColumn>
                    );
                  } else {
                    return (
                      <TableHeaderColumn
                        isKey={true}
                        dataField={data.field}
                        dataAlign="center"
                        dataSort={true}
                        filter={{
                          type: "TextFilter",
                          delay: 200,
                          placeholder: "Procurar",
                        }}
                        width="280"
                      >
                        {data.title}
                      </TableHeaderColumn>
                    );
                  }
                })}
              </BootstrapTable>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default StaffsFullSearch;



// WEBPACK FOOTER //
// ./src/Components/Staffs/StaffsFullSearch.js